// localStorage ラッパー（タスク / 設定 / 履歴）
import { AnyTask, AppSettings, DEFAULT_SETTINGS, ReactionLog } from '../types';

const KEY_TASKS = 'ktv:tasks';
const KEY_SETTINGS = 'ktv:settings';
const KEY_HISTORY = 'ktv:history';

// ===== タスク =====
export function loadTasks(): AnyTask[] {
  try {
    const raw = localStorage.getItem(KEY_TASKS);
    if (!raw) return [];
    return JSON.parse(raw) as AnyTask[];
  } catch {
    return [];
  }
}

export function saveTasks(tasks: AnyTask[]): void {
  localStorage.setItem(KEY_TASKS, JSON.stringify(tasks));
}

export function addTask(task: AnyTask): void {
  const tasks = loadTasks();
  tasks.push(task);
  saveTasks(tasks);
}

export function updateTask(taskId: string, patch: Partial<AnyTask>): void {
  const tasks = loadTasks();
  const idx = tasks.findIndex((t) => t.id === taskId);
  if (idx < 0) return;
  // 型安全に部分更新（discriminatedなので as any で済ます）
  tasks[idx] = { ...tasks[idx], ...patch } as AnyTask;
  saveTasks(tasks);
}

export function deleteTask(taskId: string): void {
  const tasks = loadTasks().filter((t) => t.id !== taskId);
  saveTasks(tasks);
}

// ===== 設定 =====
export function loadSettings(): AppSettings {
  try {
    const raw = localStorage.getItem(KEY_SETTINGS);
    if (!raw) return DEFAULT_SETTINGS;
    return { ...DEFAULT_SETTINGS, ...JSON.parse(raw) };
  } catch {
    return DEFAULT_SETTINGS;
  }
}

export function saveSettings(s: AppSettings): void {
  localStorage.setItem(KEY_SETTINGS, JSON.stringify(s));
}

// ===== 履歴 =====
const MAX_HISTORY = 500;

export function loadHistory(): ReactionLog[] {
  try {
    const raw = localStorage.getItem(KEY_HISTORY);
    if (!raw) return [];
    return JSON.parse(raw) as ReactionLog[];
  } catch {
    return [];
  }
}

export function appendHistory(log: ReactionLog): void {
  const history = loadHistory();
  history.unshift(log);
  // 上限を超えたら古いものを削除
  const trimmed = history.slice(0, MAX_HISTORY);
  localStorage.setItem(KEY_HISTORY, JSON.stringify(trimmed));
}

export function clearHistory(): void {
  localStorage.removeItem(KEY_HISTORY);
}

export function genId(): string {
  return Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
}
